module.exports = __webpack_public_path__ + "img/header_logo.f7cb3ada.svg";